export const SET_COLOR_SELECTED = 'SET_COLOR_SELECTED';

export const setColorSelected = colorSelected => ({
  type: SET_COLOR_SELECTED,
  colorSelected,
});
